import React from 'react';

interface WorkUnitsCardSkeletonProps {
  minimized?: boolean;
}

export const WorkUnitsCardSkeleton: React.FC<WorkUnitsCardSkeletonProps> = ({ minimized = false }) => {
  return (
    <div className="w-full">
      <div 
        className={`flex flex-col bg-white dark:bg-slate-800/80 border border-gray-200 dark:border-slate-700 
          rounded-lg overflow-hidden border-l-[4px] border-l-gray-200 dark:border-l-gray-700 ${minimized ? "h-[130px]" : "h-[170px]"}`}
      >
        <div className="flex-1 pt-1 px-3 pb-3 flex flex-col relative animate-pulse">
            
          {/* ROW 1: Header -> Icon + Type + Stage */}
          <div className="flex items-center py-2 gap-2">
            {/* Entity Icon Skeleton */}
            <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700 flex-shrink-0" />

            {/* Content Skeleton */}
            <div className="flex flex-col space-y-2 w-full">
               {/* Title */}
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-3/4" />
               {/* Type + Count */}
              <div className="flex items-center gap-2">
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
                  <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-8" />
              </div>
            </div>
          </div>

          <div className="flex flex-col mt-2">
             {/* ROW 2: Status + Cost */}
             <div className="flex items-center gap-2 mb-1">
                 <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-20" /> {/* Status */}
                 <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-16" /> {/* Cost */}
                 {!minimized && <div className="ml-auto h-12 w-12 bg-gray-200 dark:bg-gray-700 rounded-full" />} 
             </div>
             
             {minimized && (
                 <div className="flex justify-between mt-2 pt-1 border-t border-gray-100 dark:border-slate-700/50">
                      <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded w-24" />
                      <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded w-32" />
                 </div>
             )}
          </div>
          
          {!minimized && (
              <div className="flex items-end justify-between mt-auto pt-1 border-t border-gray-100 dark:border-slate-700/50">
                   <div className="flex flex-col gap-1">
                       <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded w-24" />
                       <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded w-32" />
                   </div>
                   <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded-full w-20" />
              </div>
          )}

        </div>
      </div>
    </div>
  );
};

